module.exports = __webpack_public_path__ + "img/aabd180.gif";